module.exports = "images/favicon-96x96.243bce20d5233edbea320977f0aa5688.png";